import FormControl from "@mui/material/FormControl/FormControl";
import MenuItem from "@mui/material/MenuItem/MenuItem";
import Select from "@mui/material/Select/Select";
import { SelectChangeEvent } from "@mui/material/Select/SelectInput";
import { IListOfBooking } from "layout/services/dtos";
import { sortListByProductNameAndBookingNumber } from "layout/utils/SupplierContainer";
import { useEffect, useState } from "react";

interface Props {
    bookingList: IListOfBooking[] | undefined;
    bookingId: string | undefined;
    onBookingDropdownChange: (bookingId: string) => void;
}

/**
 * BookingDropdown displays a dropdown of bookings.
 * When a booking is selected, it updates local state
 * and calls the provided callback with the new booking ID.
 */
function BookingDropdown({
    bookingList,
    bookingId,
    onBookingDropdownChange
}: Readonly<Props>) {
    const [selectedBooking, setSelectedBooking] = useState(bookingId || "");

    const handleChange = (event: SelectChangeEvent) => {
        const newBookingId = event.target.value;
        setSelectedBooking(newBookingId);
        // Output the new booking ID to the parent component.
        onBookingDropdownChange(newBookingId);
    };

    // Update local state when bookingId prop changes (e.g. URL change).
    useEffect(() => {
        if (bookingId) {
            setSelectedBooking(bookingId);
        }
    }, [bookingId]);

    return (
        <>
            {bookingList && (
                <FormControl className="sidebar-dropdown">
                    <Select
                        className="select-text"
                        value={selectedBooking}
                        onChange={handleChange}
                    >
                        <MenuItem disabled className="underlined">
                            Buchung wählen
                        </MenuItem>
                        {sortListByProductNameAndBookingNumber(bookingList).map(
                            (item) => (
                                <MenuItem
                                    key={item.bookingId}
                                    value={item.bookingId}
                                >
                                    {item.productName} | {item.bookingNumber}
                                </MenuItem>
                            )
                        )}
                    </Select>
                </FormControl>
            )}
        </>
    );
}

export default BookingDropdown;
